import type { Action } from '../typings/reducers';

type MailSuiteState = { active: boolean; groups: unknown[]; forms: unknown[] };
export default function (
  state: MailSuiteState = { active: false, groups: [], forms: [] },
  action: Action
): MailSuiteState {
  switch (action.type) {
    case 'set_ms_active':
      return { ...state, active: action.payload };
    case 'set_ms_groups':
      return { ...state, groups: action.payload };
    case 'set_ms_forms':
      return { ...state, forms: action.payload };
    default:
      return state;
  }
}
